import { call, METHODS } from '../http-client';

const ROUTE_PREFIX = 'margin';


export const getItems = async () => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, '');
    } catch (e) {
        console.error(`get Margin error: ${e.message}`);
        throw e;
    }
}
